export default "__VITE_ASSET__e4295f49__"